<template>
  <div class="about-page">
    <v-row justify="center" align="center">
      <v-col>
        <div class="text-center">
          <vuetify-logo />
        </div>
        <h2>{{ data.site_name }}</h2>
        <div class="card">
          <p v-html="data.about_us"></p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ServiceFactory } from "../services/ServiceFactory";
const aboutService = ServiceFactory.get("about");

import VuetifyLogo from "../components/VuetifyLogo.vue";
export default {
  data: () => ({
    data: [],
    // about:
    //   "نقدم لكم في تمرة كرم اجود انواع التمور بطرق متعدده للدفع وسياسة إسترجاع مرنه.",
  }),
  components: {
    VuetifyLogo,
  },

  methods: {
    async fetchAllItems() {
      this.dataLoading = true;
      this.data = await aboutService.getAboutData();

      this.dataLoading = false;
    },
  },
  mounted() {
    this.fetchAllItems();
    // console.log("saf");
  },
};
</script>

<style>
.about-page {
  text-align: center;
}
.about-page h2 {
  margin: 50px 0 30px 0;
  text-align: center;
  color: #614c37 !important;
  font-size: 15px !important;
}
.about-page .card {
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.18);
  margin: auto;
  background: #fff;
  border-radius: 20px;
  padding: 15px;
  margin-bottom: 30px;
}
.about-page .card p {
  font-size: 15px !important;
  color: #5a5a5a;
  font-weight: normal;
  /* font-family: "Roboto", sans-serif !important; */
}
</style>
